/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Contents } from '../../models/contents';

export interface ApiMasterContentGetActiveGet$Params {
}

export function apiMasterContentGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Contents>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterContentGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Contents>>;
    })
  );
}

apiMasterContentGetActiveGet.PATH = '/api/Master/Content/GetActive';
